import { Suspense } from 'react';
import { GetCart } from './CartHandler';
import { formatter } from '../../utils/common.js'
import { useState, useEffect } from 'react';
import axios from 'axios';
import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import AddressModal from './AddressModal.js';
import PaymentForm from './PaymentForm.js';
import "./addressModal.css"
import PaymentIcon from '@mui/icons-material/Payment';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/24/solid";
import { PlusIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { Dialog } from "@headlessui/react";
import { Modal, Box, Grid, TextField, Typography } from '@mui/material';
import "./addressModal.css";


const apiUrl = process.env.REACT_APP_BASEURL;

function AddressBlock(props) {

    const token = useState(props.token.token);
    const customer = useState(token.customerName);
    const cart = GetCart();
    const [billingAddress, setBillingAddress] = useState({})
    const [shippingAddress, setShippingAddress] = useState({})
    const [selectedValue, setSelectedValue] = React.useState('a');
    const [paymentRatio, setPaymentRatio] = React.useState('a');
    const [selectedPaymentIndex, setSelectedPaymentIndex] = useState(null); // Track selected payment index
    const [billingValue, setBillingValue] = React.useState('e');
    const [expanded, setExpanded] = useState(false);
    const [shippingExpanded, setShippingExpanded] = useState(false);
    const [paymentExpanded, setPaymentExpanded] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState("")
    const [isExpanded, setIsExpanded] = useState(false);
    const [firstExpanded, setFirstExpanded] = useState(false);
    const [secondExpanded, setSecondExpanded] = useState(false);



    // Function to handle Accordion toggle
    const handleToggle = () => {
        setIsExpanded(!isExpanded);
    };
    const handleFirstToggle = () => {
        setFirstExpanded(!firstExpanded);
    };
    const handleSecToggle = () => {
        setSecondExpanded(!secondExpanded);
    };
    const shippingAddData = [
        "near 23425 south", 'far 3463 north', 'so close 2534 center', 'near by 4535 downtown'
    ]
    const billingAddData = [
        "st louis", 'st charles', 'st peters', 'chesterfield'
    ]
    const [shippingAdd, setShippingAdd] = useState(shippingAddData[0])
    const [billingAdd, setBillingAdd] = useState(billingAddData[0])
    const [paymentsSelection, setPaymentsSelection] = useState([
        ["Mustafa Hussaini", "Saint Louis", "Card ending with 4543"],
        ["Michael Hollingsworth", "Saint Peters", "Card ending with 6345"],
    ]);
    const [selectedPayment, setSelectedPayment] = useState(paymentsSelection[0])
    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };
    const billingHandleChange = (event) => {
        setBillingValue(event.target.value);
    };
    const paymentRatioHandle = (event) => {
        setSelectedPaymentIndex(event.target.value);
    };
    // Function to add new payment
    const addPaymentMethod = (name, location, cardEnding) => {
        const newPayment = [name, location, cardEnding];
        setPaymentsSelection([...paymentsSelection, newPayment]);
    };

    const handleRemovePayment = () => {
        if (selectedPaymentIndex !== null) {
            const updatedPayments = paymentsSelection.filter((_, index) => index !== selectedPaymentIndex);
            setPaymentsSelection(updatedPayments);
            setSelectedPaymentIndex(null); // Reset selected payment index
        }
    };


    useEffect(() => {
        getBillingAddress();
        getShippingAddress();
    }, []);

    const handlepaymentOptions = (event) => {
        setPaymentMethod(event.target.value);
    };

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const closeAccordion = () => {
        setExpanded(false);
    };
    const handleAccordionSh = (pane2) => (event, isExpanded) => {
        setShippingExpanded(isExpanded ? pane2 : false);
    };
    const handleAccordionShil = (pane3) => (event, isExpanded) => {
        setPaymentExpanded(isExpanded ? pane3 : false);
    };

    const handleShippingClose = () => {
        setShippingExpanded(false);
    };


    const testShippingAddress = () => {
        if (shippingAddData.length !== 0) {
            return (
                <ul>
                    <div className='radio-cover'>
                        <div className='flex'>
                            <Radio
                                onChange={handleChange}
                                onClick={() => setShippingAdd(shippingAddData[0])}
                                checked={selectedValue === 'a'}
                                value="a"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'A' }}
                            />
                            <li className='cursor-pointer lg:mt-2 w-[8rem]'  >{shippingAddData[0]}</li>

                        </div>
                        <div className='flex'>
                            <Radio
                                onClick={() => setShippingAdd(shippingAddData[1])}
                                checked={selectedValue === 'b'}
                                onChange={handleChange}
                                value="b"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'B' }}
                            />
                            <li className='cursor-pointer lg:mt-2' >{shippingAddData[1]}</li>

                        </div>
                        <div className='flex'>
                            <Radio
                                onClick={() => setShippingAdd(shippingAddData[2])}
                                checked={selectedValue === 'c'}
                                onChange={handleChange}
                                value="c"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'C' }}
                            />
                            <li className='cursor-pointer lg:mt-2' >{shippingAddData[2]}</li>

                        </div>
                        <div className='flex'>
                            <Radio
                                onClick={() => setShippingAdd(shippingAddData[3])}
                                checked={selectedValue === 'd'}
                                onChange={handleChange}
                                value="d"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'D' }}
                            />
                            <li className='cursor-pointer lg:mt-2' >{shippingAddData[3]}</li>

                        </div>

                    </div>
                </ul>
            )
        } else {
            return (
                <div>Error Appeared!</div>
            )
        }
    }
    const PaymentsOptions = () => {
        if (paymentsSelection.length !== 0) {
            return (
                <ul>
                    <div className="radio-cover">
                        {paymentsSelection.map((payment, index) => {
                            const value = String.fromCharCode(97 + index); // Generate values "a", "b", "c", "d" based on index

                            return (
                                <div className="flex" key={index}>
                                    <Radio
                                        onClick={() => setSelectedPayment(payment)}
                                        checked={selectedPaymentIndex === value}
                                        onChange={paymentRatioHandle}
                                        value={value}
                                        name="radio-buttons"
                                        inputProps={{ 'aria-label': value.toUpperCase() }}
                                    />
                                    <ul className="cursor-pointer lg:mt-4 ">
                                        {payment.map((detail, detailIndex) => (
                                            <li className='' key={detailIndex}>{detail}</li>
                                        ))}
                                    </ul>
                                </div>
                            );
                        })}
                    </div>
                </ul>
            );
        } else {
            return <div>Error Appeared!</div>;
        }
    }
    const testBillingAddress = () => {
        if (shippingAddData.length !== 0) {
            return (
                <ul>
                    <div className='radio-cover'>
                        <div className='flex'>
                            <Radio
                                onChange={billingHandleChange}
                                onClick={() => setBillingAdd(billingAddData[0])}
                                checked={billingValue === 'e'}
                                value="e"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'E' }}
                            />
                            <li className='cursor-pointer lg:mt-2 w-[3rem]'  >{billingAddData[0]}</li>

                        </div>
                        <div className='flex'>
                            <Radio
                                onClick={() => setBillingAdd(billingAddData[1])}
                                checked={billingValue === 'f'}
                                onChange={billingHandleChange}
                                value="f"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'F' }}
                            />
                            <li className='cursor-pointer lg:mt-2' >{billingAddData[1]}</li>

                        </div>
                        <div className='flex'>
                            <Radio
                                onClick={() => setBillingAdd(billingAddData[2])}
                                checked={billingValue === 'g'}
                                onChange={billingHandleChange}
                                value="g"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'G' }}
                            />
                            <li className='cursor-pointer lg:mt-2' >{billingAddData[2]}</li>

                        </div>
                        <div className='flex'>
                            <Radio
                                onClick={() => setBillingAdd(billingAddData[3])}
                                checked={billingValue === 'h'}
                                onChange={billingHandleChange}
                                value="h"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'H' }}
                            />
                            <li className='cursor-pointer lg:mt-2' >{billingAddData[3]}</li>

                        </div>

                    </div>
                </ul>
            )
        } else {
            return (
                <div>Error Appeared!</div>
            )
        }
    }


    const getBillingAddress = () => {

        axios
            .get(apiUrl + `/api/Users/GetBillingAddress`, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + props.token.token
                },
            })
            .then((response) => {
                setBillingAddress(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getShippingAddress = () => {
        axios
            .get(apiUrl + `/api/Users/GetShippingAddress`, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + props.token.token
                },
            })
            .then((response) => {
                setShippingAddress(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const billingAddressReturn = () => {
        if (!billingAddress.address1) {
            return (
                <>
                    <div className='lg:mt-2'>
                        Getting your billing address....
                    </div>
                </>
            );
        } else {
            return (
                <>

                    <Suspense fallback={<h2>Loading...</h2>}>
                        <div className='flex'>
                            <label className='lg:mt-2'>
                                {billingAddress.address1.trim() + ', '}
                                {!!billingAddress.address2 && !!billingAddress.address2.trim() ? billingAddress.address2 + ', ' : null}
                                {billingAddress.city + ', '}
                                {billingAddress.state + ' '}
                                {billingAddress.zip}
                            </label>
                        </div>
                    </Suspense>
                </>
            );
        }
    }

    const shippingAddressReturn = () => {
        if (!shippingAddress.address1) {
            return (
                <>
                    <div className='lg:mt-2'>
                        Getting your shipping address....
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <Suspense fallback={<div>Loading...</div>}>
                        <div className='flex'>
                            <label className='lg:mt-2'>
                                {shippingAddress.address1 + ', '}
                                {!!shippingAddress.address2 && !!billingAddress.address2 ? shippingAddress.address2 + ', ' : null}
                                {shippingAddress.city + ', '}
                                {shippingAddress.state + ' '}
                                {shippingAddress.zip}
                            </label>
                        </div>
                    </Suspense>
                </>
            );
        }
    }

    const handleShippingSelect = () => {
        setBillingAddress(shippingAddData[1])
    }

    const [pOpen, setPOpen] = React.useState(false);
    const handlePayOpen = () => setPOpen(true);
    const handleClosePay = () => setPOpen(false);


    const user = {
        fullName: "John Doe",
        addresses: [
            "123 Main St, Springfield, IL",
            "456 Oak St, Austin, TX",
            "789 Pine St, Seattle, WA",
        ],
    };

    const [addresses, setAddresses] = useState(user.addresses);
    const [selectedAddress, setSelectedAddress] = useState(user.addresses[0]);
    const [savedAddress, setSavedAddress] = useState(user.addresses[0]);
    const [newAddress, setNewAddress] = useState("");
    const [open, setOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        borderRadius: '8px',
        boxShadow: 24,
        p: 4,
    };


    const handleClose = () => setOpen(false);
    const handleOpen = () => setOpen(true);

    const addNewAddress = () => {
        if (newAddress.trim() !== "") {
            setAddresses([...addresses, newAddress]);
            setNewAddress("");
            handleClose();
        }
    };

    const saveAddress = () => {
        // Your save address logic
        console.log('Address saved');
    };

    const [paymentType, setPaymentType] = useState('Credit Card');
    const [cardInfo, setCardInfo] = useState({
        cardType: 'Visa',
        cardHolder: 'John Doe',
        lastFour: '1234',
    });

    const savedCards = [
        { cardType: 'Visa', cardHolder: 'Jane Smith', lastFour: '5678' },
        { cardType: 'MasterCard', cardHolder: 'Alex Johnson', lastFour: '4321' },
        { cardType: 'American Express', cardHolder: 'Emily Brown', lastFour: '9876' },
    ];

    const handleCardSelect = (card) => {
        setCardInfo(card);
    };

    const handlePaymentTypeChange = (e) => {
        const selectedOptions = Array.from(e.target.selectedOptions, (option) => option.value);
        setPaymentType(selectedOptions);
    };

    return (
        <div id="" className="">
            <h3>{customer}</h3>
            <div className="">
                <div className="flex items-center space-x-4 p-2 bg-gray-50 rounded-lg shadow-sm">
                    <strong className="text-md font-semibold text-gray-700">Billing Address</strong>
                    <div className="text-sm text-gray-600">{billingAddress ? billingAddressReturn() : 'No billing address provided'}</div>
                </div>

                <div className="flex items-center space-x-4 p-2 bg-gray-50 rounded-lg shadow-sm">
                    <strong className="text-md font-semibold text-gray-700">Shipping Address</strong>
                    <div className="text-sm text-gray-600">{shippingAddress ? shippingAddressReturn() : 'No shipping address provided'}</div>
                </div>
            </div>

            <div className='w-[100%]'>
                <div>

                </div>
                <div className="flex flex-wrap md:flex-nowrap w-auto justify-around">
                    <div className="flex flex-wrap md:flex-nowrap w-auto gap-4 justify-around">
                        <div className="max-w-md  mt-10 p-4 bg-white shadow-lg rounded-lg h-auto">
                            {/* User Full Name */}
                            <p className="text-lg font-semibold">{user.fullName}</p>

                            {/* Saved Address */}
                            <p className="text-gray-700">{selectedAddress}</p>

                            {/* Accordion for Address Selection */}
                            <Disclosure>
                                {({ open }) => (
                                    <>
                                        <Disclosure.Button
                                            onClick={() => setIsEditing(true)}
                                            className="mt-4 flex w-full justify-between rounded-lg bg-blue-500 px-4 py-2 text-white text-sm font-medium hover:bg-blue-600"
                                        >
                                            <span>Change Address</span>
                                            <ChevronUpIcon className={`h-5 w-5 transform transition-transform ${open ? "rotate-180" : ""}`} />
                                        </Disclosure.Button>

                                        <Disclosure.Panel className="mt-2 space-y-2">
                                            {addresses.map((address, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => setSelectedAddress(address)}
                                                    className={`block w-full text-left p-2 rounded-md ${selectedAddress === address ? "bg-blue-100 text-blue-600 font-semibold" : "hover:bg-gray-100"}`}
                                                >
                                                    {address}
                                                </button>
                                            ))}
                                        </Disclosure.Panel>

                                        {/* Show Buttons Only After Clicking Change Address */}
                                        {open && isEditing && (
                                            <div className="mt-4 flex gap-2">
                                                <button
                                                    onClick={saveAddress}
                                                    className="flex-1 bg-green-500 text-white py-2 rounded-lg hover:bg-green-600"
                                                >
                                                    Save
                                                </button>
                                                <button
                                                    onClick={() => setIsModalOpen(true)}
                                                    className="flex-1 flex items-center justify-center gap-1 bg-gray-500 text-white py-2 rounded-lg hover:bg-gray-600"
                                                >
                                                    <PlusIcon className="h-5 w-5" />
                                                    Add
                                                </button>
                                            </div>
                                        )}
                                    </>
                                )}
                            </Disclosure>

                            {/* Modal for Adding New Address */}
                            <div>
                                <Modal
                                    open={isModalOpen}
                                    className=''
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                >
                                    <Box sx={style} className="ch-address">
                                        <Grid container spacing={{ xs: 2, md: 3 }} rowGap={{ xs: 2, sm: 2, md: 2 }}>
                                            <Grid container display={"flex"} flexDirection={"column"}>
                                                <Grid xs className=' lg:mt-2 ' container justifyContent={"center"}>
                                                    <Typography variant='h4'>
                                                        Add New Address
                                                    </Typography>
                                                </Grid>
                                                <Grid xs className=' lg:mt-2 lg:w-[4rem] ' container justifyContent={"right"} >
                                                    <Typography variant='body1' className='shp-add'>
                                                        Shipping Address
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container rowGap={{ xs: 2, sm: 2, md: 2 }} className='lg:mt-[3rem]' >
                                                <Grid className='' xs={12} sm={2} md={12} container justifyContent="center">
                                                    <TextField className='lg:w-[35rem] w-[22rem]' label="Address 1" value={newAddress} onChange={(e) => setNewAddress(e.target.value)} />
                                                </Grid>
                                                <Grid xs={12} sm={4} md={12} container justifyContent="center">
                                                    <TextField className='lg:w-[35rem] w-[22rem]' label="Address 2" />
                                                </Grid>
                                                <Grid xs={5} sm={4} md={5} container justifyContent="center" className='state' textAlign={"right"} >
                                                    <TextField className='lg:w-[7rem] w-[6rem]' label="State" type='text' />
                                                </Grid>
                                                <Grid xs={2} sm={4} md={2} container justifyContent="center" textAlign={"center"} >
                                                    <TextField className='lg:w-[13rem]' label="City" type='text' />
                                                </Grid>
                                                <Grid xs={5} sm={4} md={5} container justifyContent="center" className='zipcode' textAlign={"left"}>
                                                    <TextField className='lg:w-[7rem] w-[6rem]' label="Zip Code" type='text' />
                                                </Grid>
                                                <Grid className='' xs={6} sm={4} md={6} justifyContent="center" textAlign={"right"}>
                                                    <TextField label="Email Address" className='lg:w-[17.5rem] w-[11rem]' />
                                                </Grid>
                                                <Grid className='lg:pl-4 pl-2' xs={6} sm={4} md={6} justifyContent="center" textAlign={"left"}>
                                                    <TextField type='tel' label="Phone Number" className='lg:w-[16.5rem] w-[11rem]' />
                                                </Grid>
                                            </Grid>
                                            <Grid container className='lg:mt-[4rem] mt-[4rem]' justifyContent={"center"} textAlign={"center"}>
                                                <Grid >
                                                    <Button
                                                        className="ad-cancel "
                                                        onClick={() => setIsModalOpen(false)}
                                                        variant=""
                                                        type="submit"
                                                        sx={{ padding: ".8rem 1rem", marginTop: "2rem", width: "8rem", border: 'solid 1px', color: '#1976d2' }}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Grid>
                                                <Grid>
                                                    <Button
                                                        className="ad-continue"
                                                        onClick={addNewAddress}
                                                        variant=""
                                                        sx={{ padding: ".8rem 1rem", marginTop: "2rem", width: "8rem", marginLeft: "1rem", border: 'solid 1px', color: '#1976d2' }}
                                                    >
                                                        Continue
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Modal>
                            </div>
                        </div>

                        <div className="max-w-md  mt-10 p-4 bg-white shadow-lg rounded-lg h-auto">
                            {/* User Full Name */}
                            <p className="text-lg font-semibold">{user.fullName}</p>

                            {/* Saved Address */}
                            <p className="text-gray-700">{selectedAddress}</p>

                            {/* Accordion for Address Selection */}
                            <Disclosure>
                                {({ open }) => (
                                    <>
                                        <Disclosure.Button
                                            onClick={() => setIsEditing(true)}
                                            className="mt-4 flex w-full justify-between rounded-lg bg-blue-500 px-4 py-2 text-white text-sm font-medium hover:bg-blue-600"
                                        >
                                            <span>Change Address</span>
                                            <ChevronUpIcon className={`h-5 w-5 transform transition-transform ${open ? "rotate-180" : ""}`} />
                                        </Disclosure.Button>

                                        <Disclosure.Panel className="mt-2 space-y-2">
                                            {addresses.map((address, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => setSelectedAddress(address)}
                                                    className={`block w-full text-left p-2 rounded-md ${selectedAddress === address ? "bg-blue-100 text-blue-600 font-semibold" : "hover:bg-gray-100"}`}
                                                >
                                                    {address}
                                                </button>
                                            ))}
                                        </Disclosure.Panel>

                                        {/* Show Buttons Only After Clicking Change Address */}
                                        {open && isEditing && (
                                            <div className="mt-4 flex gap-2">
                                                <button
                                                    onClick={saveAddress}
                                                    className="flex-1 bg-green-500 text-white py-2 rounded-lg hover:bg-green-600"
                                                >
                                                    Save
                                                </button>
                                                <button
                                                    onClick={() => setIsModalOpen(true)}
                                                    className="flex-1 flex items-center justify-center gap-1 bg-gray-500 text-white py-2 rounded-lg hover:bg-gray-600"
                                                >
                                                    <PlusIcon className="h-5 w-5" />
                                                    Add
                                                </button>
                                            </div>
                                        )}
                                    </>
                                )}
                            </Disclosure>

                            {/* Modal for Adding New Address */}
                            <div>
                                <Modal
                                    open={isModalOpen}
                                    className=''
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                >
                                    <Box sx={style} className="ch-address">
                                        <Grid container spacing={{ xs: 2, md: 3 }} rowGap={{ xs: 2, sm: 2, md: 2 }}>
                                            <Grid container display={"flex"} flexDirection={"column"}>
                                                <Grid xs className=' lg:mt-2 ' container justifyContent={"center"}>
                                                    <Typography variant='h4'>
                                                        Add New Address
                                                    </Typography>
                                                </Grid>
                                                <Grid xs className=' lg:mt-2 lg:w-[4rem] ' container justifyContent={"right"} >
                                                    <Typography variant='body1' className='shp-add'>
                                                        Shipping Address
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container rowGap={{ xs: 2, sm: 2, md: 2 }} className='lg:mt-[3rem]' >
                                                <Grid className='' xs={12} sm={2} md={12} container justifyContent="center">
                                                    <TextField className='lg:w-[35rem] w-[22rem]' label="Address 1" value={newAddress} onChange={(e) => setNewAddress(e.target.value)} />
                                                </Grid>
                                                <Grid xs={12} sm={4} md={12} container justifyContent="center">
                                                    <TextField className='lg:w-[35rem] w-[22rem]' label="Address 2" />
                                                </Grid>
                                                <Grid xs={5} sm={4} md={5} container justifyContent="center" className='state' textAlign={"right"} >
                                                    <TextField className='lg:w-[7rem] w-[6rem]' label="State" type='text' />
                                                </Grid>
                                                <Grid xs={2} sm={4} md={2} container justifyContent="center" textAlign={"center"} >
                                                    <TextField className='lg:w-[13rem]' label="City" type='text' />
                                                </Grid>
                                                <Grid xs={5} sm={4} md={5} container justifyContent="center" className='zipcode' textAlign={"left"}>
                                                    <TextField className='lg:w-[7rem] w-[6rem]' label="Zip Code" type='text' />
                                                </Grid>
                                                <Grid className='' xs={6} sm={4} md={6} justifyContent="center" textAlign={"right"}>
                                                    <TextField label="Email Address" className='lg:w-[17.5rem] w-[11rem]' />
                                                </Grid>
                                                <Grid className='lg:pl-4 pl-2' xs={6} sm={4} md={6} justifyContent="center" textAlign={"left"}>
                                                    <TextField type='tel' label="Phone Number" className='lg:w-[16.5rem] w-[11rem]' />
                                                </Grid>
                                            </Grid>
                                            <Grid container className='lg:mt-[4rem] mt-[4rem]' justifyContent={"center"} textAlign={"center"}>
                                                <Grid >
                                                    <Button
                                                        className="ad-cancel "
                                                        onClick={() => setIsModalOpen(false)}
                                                        variant=""
                                                        type="submit"
                                                        sx={{ padding: ".8rem 1rem", marginTop: "2rem", width: "8rem", border: 'solid 1px', color: '#1976d2' }}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Grid>
                                                <Grid>
                                                    <Button
                                                        className="ad-continue"
                                                        onClick={addNewAddress}
                                                        variant=""
                                                        sx={{ padding: ".8rem 1rem", marginTop: "2rem", width: "8rem", marginLeft: "1rem", border: 'solid 1px', color: '#1976d2' }}
                                                    >
                                                        Continue
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Modal>
                            </div>
                        </div>

                    </div>

                    <div className="max-w-xl md:max-w-lg  p-4">
                        <div className="bg-gray-100 p-4 bg-white shadow-lg rounded-lg ">
                            <h2 className="text-xl font-semibold">Payment Method</h2>
                            <div className="mt-4">
                                <div className="flex items-center space-x-4">
                                    <span className="font-medium">Payment Type: </span>
                                    <span>{paymentType}</span>
                                </div>
                                <div className="flex items-center space-x-4 mt-2">
                                    <span className="font-medium">Card Holder: </span>
                                    <span>{cardInfo.cardHolder}</span>
                                </div>
                                <div className="flex items-center space-x-4 mt-2">
                                    <span className="font-medium">Card Ending: </span>
                                    <span>**** **** **** {cardInfo.lastFour}</span>
                                </div>
                            </div>
                        </div>

                        {/* Payment Type Dropdown */}
                        <div className="relative mt-4">
                            <Disclosure>
                                {({ open }) => (
                                    <>
                                        <Disclosure.Button className="w-full text-left bg-gray-200 px-4 py-2 rounded-md hover:bg-gray-300 cursor-pointer">
                                            <span className="font-medium">Select Payment Type</span>
                                            <span className="ml-2 text-gray-500">{open ? '▲' : '▼'}</span>
                                        </Disclosure.Button>
                                        <Disclosure.Panel className="absolute mt-2 w-48 bg-white shadow-lg rounded-md border border-gray-200">
                                            <ul>
                                                <li
                                                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                                                    onClick={() => setPaymentType('Credit Card')}
                                                >
                                                    Credit Card
                                                </li>
                                                <li
                                                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                                                    onClick={() => setPaymentType('PayPal')}
                                                >
                                                    PayPal
                                                </li>
                                                <li
                                                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                                                    onClick={() => setPaymentType('Bank Transfer')}
                                                >
                                                    Bank Transfer
                                                </li>
                                                <li
                                                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                                                    onClick={() => setPaymentType('Apple Pay')}
                                                >
                                                    Apple Pay
                                                </li>
                                            </ul>
                                        </Disclosure.Panel>
                                    </>
                                )}
                            </Disclosure>
                        </div>

                        {/* Saved Cards */}
                        <div className="mt-6">
                            <Disclosure>
                                {({ open }) => (
                                    <>
                                        <Disclosure.Button className="w-full text-left bg-gray-200 px-4 py-2 rounded-md">
                                            <span className="font-medium">Saved Cards</span>
                                            <span className="ml-2 text-gray-500">{open ? 'Hide' : 'Show'}</span>
                                        </Disclosure.Button>
                                        <Disclosure.Panel className="bg-gray-50 p-4 mt-2 rounded-md">
                                            <ul>
                                                {savedCards.map((card, index) => (
                                                    <li
                                                        key={index}
                                                        className="flex justify-between items-center py-2 px-4 rounded-lg hover:bg-gray-200 cursor-pointer"
                                                        onClick={() => handleCardSelect(card)}
                                                    >
                                                        <span>{card.cardType} - {card.cardHolder}</span>
                                                        <span>**** **** **** {card.lastFour}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </Disclosure.Panel>
                                    </>
                                )}
                            </Disclosure>
                        </div>
                    </div>

                    <div className="overflow-x-auto max-w-2xl shadow-md sm:rounded-lg sm:mt-4  border">
                        <table className="  text-sm text-left text-gray-500 border-none">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100">
                                <tr>
                                    <th className="px-6 py-3">Item Number</th>
                                    <th className="px-6 py-3">Price</th>
                                    <th className="px-6 py-3">Quantity</th>
                                    <th className="px-6 py-3">Lot #</th>
                                    <th className="px-6 py-3">Roll #</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cart.map((item) => (
                                    <tr key={item.ItemNumber} className="">
                                        <td className="px-6 py-4">{item.ItemNumber}</td>
                                        <td className="px-6 py-4">{formatter.format(item.Price)}</td>
                                        <td className="px-6 py-4">{item.Quantity}</td>
                                        <td className="px-6 py-4">{"empty"}</td>
                                        <td className="px-6 py-4">{"empty"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            {<AddressModal handleClose={handleClose} handleOpen={handleOpen} open={open} />}
            {<PaymentForm handleClose={handleClosePay} handleOpen={handlePayOpen} open={pOpen}
                addPaymentMethod={addPaymentMethod} paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod} />}
        </div>
    );
}




//class AddressBlock extends React.Component {
// constructor() {
//     super();
//     this.state = {
//         name: 'React',            
//         billingAddress: null,
//         shippingAddress: null,
//         customer: ""
//     };
// }

// async componentDidMount() {
//     const tokenString = sessionStorage.getItem("token");
//     const token = JSON.parse(tokenString);

//     this.setState({ customer: token.customerName });

//     let headers = new Headers({
//         "Accept": "application/json",
//         "Content-Type": "application/json",
//         'Authorization': 'Bearer ' + token.token
//     });

//     const bresponse = await fetch(apiUrl + `/api/Users/GetBillingAddress`, {
//         method: "GET",
//         headers: headers
//     });
//     const bjson = await bresponse.json();
//     console.log(bjson);
//     this.setState({ billingAddress: bjson });

//     const sresponse = await fetch(apiUrl + `/api/Users/GetShippingAddress`, {
//         method: "GET",
//         headers: headers
//     });
//     const sjson = await sresponse.json();
//     console.log(sjson);
//     this.setState({ shippingAddress: sjson });
// }

// render() {
//     const billingAddress = this.state.billingAddress;
//     const shippingAddress = this.state.shippingAddress;
//     const cart = GetCart();

//      function GetBillingAddress() {
//             return (
//                 <>
//                     <strong>Billing: </strong>
//                     <Suspense fallback={<div>Loading...</div>}>
//                         <label>
//                             {billingAddress.address1.trim() + ', '}
//                             {!!billingAddress.address2 && !!billingAddress.address2.trim() ? billingAddress.address2 + ', ' : null}
//                             {billingAddress.city + ', '}
//                             {billingAddress.state + ' '}
//                             {billingAddress.zip}
//                         </label>
//                     </Suspense>
//                 </>
//             );
//         }

//         function GetShippingAddress() {
//             return (
//                 <>
//                     <strong>Shipping: </strong>
//                     <Suspense fallback={<div>Loading...</div>}>
//                         <label>
//                             {shippingAddress.address1.trim() + ', '}
//                             {!!shippingAddress.address2 && !!billingAddress.address2.trim() ? shippingAddress.address2 + ', ' : null}
//                             {shippingAddress.city + ', '}
//                             {shippingAddress.state + ' '}
//                             {shippingAddress.zip}
//                         </label>
//                     </Suspense>
//                 </>
//             );
//         }

//         return (
//             <div id="checkout" className="block col-2">
//                 <h3>{this.state.customer}</h3>
//                 <div className="row">
//                     <div>
//                         {billingAddress === null ? 'Loading...' : GetBillingAddress()}
//                     </div>
//                     <div>
//                         {shippingAddress === null ? 'Loading...' : GetShippingAddress()}
//                     </div>
//                 </div>
//                 <div>
//                 <div className="table-wrapper">
//                     <table className="table table-striped table-bordered table-extra">
//                         <thead>
//                             <tr>
//                                 <th className="number">Item Number</th>
//                                 <th className="price">Price</th>
//                                 <th className="quantity">Quantity</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {cart.map(item =>
//                                 <tr key={item.ItemNumber}>
//                                     <td>{item.ItemNumber}</td>
//                                     <td>{formatter.format(item.Price)}</td>
//                                     <td>{item.Quantity}</td>                                    
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                     </div>
//                 </div>
//             </div>
//         );
//     }
// }
export default AddressBlock;
